import React from "react";
import { RefreshCw } from "lucide-react";
import { Card, CardContent } from "../misc/Card";
import { Button } from "../misc/Button";

interface AnalyticsErrorStateProps {
    message: string;
    onRetry: () => void;
}

const AnalyticsErrorState: React.FC<AnalyticsErrorStateProps> = ({ message, onRetry }) => (
    <Card className="mt-0">
        <CardContent className="flex flex-col items-center py-10 text-center">
            <h2 className="text-lg font-semibold text-primary">We couldn't load your analytics</h2>
            <p className="mt-1 max-w-md text-sm text-gray-500">{message}</p>
            <Button onClick={onRetry} variant="secondary" className="mt-4">
                <RefreshCw className="h-4 w-4" />
                Try again
            </Button>
        </CardContent>
    </Card>
);

export default AnalyticsErrorState;
